<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="31.698"
    height="27.393"
    viewBox="0 0 31.698 27.393"
  >
    <defs>
      <clipPath id="clip-path">
        <path
          id="Trazado_173"
          data-name="Trazado 173"
          d="M1125.392,3341.84a2.572,2.572,0,0,1-1.992-.805l7.619-7.583c.2.187.4.383.593.579,1.1,1.094,2.24,2.227,4.185,2.243h.039c1.946,0,3.065-1.132,4.149-2.229.2-.2.4-.4.6-.59l7.6,7.67a2.582,2.582,0,0,1-1.914.715q-5.221.006-10.44.007t-10.44-.007m-2.787-16.41,6.135,6.1-6.135,6.088Zm20.4,5.9,6.054-6.038V3337.4Zm-9.191,1.178q-2.494-2.469-4.97-4.955-2.841-2.844-5.7-5.674c-.378-.373-.4-.6-.079-1.024a2.856,2.856,0,0,1,2.447-1.2h.012q3.807.009,7.607,0l5.3,0q3.87,0,7.742,0h.007a2.615,2.615,0,0,1,2.446,1.318.939.939,0,0,1-.035.758c-4.344,4.416-7.7,7.769-10.863,10.876a2.694,2.694,0,0,1-1.887.86,2.915,2.915,0,0,1-2.032-.957m-8.994-15.464a4.591,4.591,0,0,0-4.85,4.835q0,8.879,0,17.756a4.485,4.485,0,0,0,4.77,4.789q5.546.007,11.086.008t11.085-.008a4.593,4.593,0,0,0,4.749-4.733q.012-8.931,0-17.863a4.535,4.535,0,0,0-4.779-4.784q-3.957-.007-7.916,0h-8.824q-2.66,0-5.321,0"
          :fill="coloricon"
        />
      </clipPath>
    </defs>
    <g
      id="icono_correo"
      data-name="icono correo"
      transform="translate(-1119.968 -3317.038)"
    >
      <path
        id="Trazado_172"
        data-name="Trazado 172"
        d="M1125.392,3341.84a2.572,2.572,0,0,1-1.992-.805l7.619-7.583c.2.187.4.383.593.579,1.1,1.094,2.24,2.227,4.185,2.243h.039c1.946,0,3.065-1.132,4.149-2.229.2-.2.4-.4.6-.59l7.6,7.67a2.582,2.582,0,0,1-1.914.715q-5.221.006-10.44.007t-10.44-.007m-2.787-16.41,6.135,6.1-6.135,6.088Zm20.4,5.9,6.054-6.038V3337.4Zm-9.191,1.178q-2.494-2.469-4.97-4.955-2.841-2.844-5.7-5.674c-.378-.373-.4-.6-.079-1.024a2.856,2.856,0,0,1,2.447-1.2h.012q3.807.009,7.607,0l5.3,0q3.87,0,7.742,0h.007a2.615,2.615,0,0,1,2.446,1.318.939.939,0,0,1-.035.758c-4.344,4.416-7.7,7.769-10.863,10.876a2.694,2.694,0,0,1-1.887.86,2.915,2.915,0,0,1-2.032-.957m-8.994-15.464a4.591,4.591,0,0,0-4.85,4.835q0,8.879,0,17.756a4.485,4.485,0,0,0,4.77,4.789q5.546.007,11.086.008t11.085-.008a4.593,4.593,0,0,0,4.749-4.733q.012-8.931,0-17.863a4.535,4.535,0,0,0-4.779-4.784q-3.957-.007-7.916,0h-8.824q-2.66,0-5.321,0"
        :fill="coloricon"
      />
      <g id="Grupo_103" data-name="Grupo 103" clip-path="url(#clip-path)">
        <rect
          id="Rectángulo_138"
          data-name="Rectángulo 138"
          width="31.787"
          height="27.492"
          transform="translate(1119.88 3317.038) rotate(-0.18)"
          :fill="coloricon"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    coloricon: {
      default: "#b9b9b9",
    },
  },
};
</script>
